import { store } from '@/store';
import { translate } from '@/utilities';
import constants from '@/utilities/constants';
import { handleAddEventBoardView } from '@/utilities/moveCard';
import getDashedTitle from '@/utilities/getDashedTitle';
import { getSprintListKey, getSprintKey } from '@/utilities/sprintKeys';
import router from '@/router';

const openCard = (card) => {
  if (card && Object.keys(card).length) {
    const cardPath = `/${store.getters.getTeamSlug}/card-${card.id}-${getDashedTitle(card.title)}`;

    store.dispatch('setCurrentProjectId', card.project_id);
    store.dispatch('setCurrentBoardId', card.board_id);

    store.dispatch('setDisplayedCards', [card.id]);
    if (store.getters.getCurrentRoute.path !== cardPath) {
      router.push({
        path: cardPath,
        query: {
          cardMoved: true,
        },
      });
    }
  }
};

const dropCardIntoBoard = async ({ cardId, destinationBoardId, showNotification = true }) => {
  const card = { ...store.getters.getCards[cardId] };
  const destinationBoard = store.getters.getFlatBoards[destinationBoardId];

  if (!destinationBoard) return;
  if (destinationBoard.list_order?.length === 0) {
    const notification = {
      message: translate('thereAreNoListInBoard'),
      status: constants.uiNotificationStatuses.error,
      duration: 3000,
    };
    if (showNotification) {
      store.dispatch('addUiNotification', notification);
    }
    return Promise.reject(new Error('thereAreNoListInBoard'));
  }

  const [destinationBoardListId] =
    store.getters.boardsListsIds[destinationBoardId] || destinationBoard.list_order || [];
  const destinationList = store.getters.lists[destinationBoardListId];
  const cardListId = card.sprint_id
    ? getSprintListKey(card.project_id, card.sprint_id, card.list_id)
    : card.list_id;
  const originalList = store.getters.lists[cardListId];
  const position = destinationList?.card_order?.length ?? 0;
  const currentCardIndex = originalList?.card_order?.findIndex((id) => id === card.id);
  const boardId = card.board_id || getSprintKey(card.project_id, card.sprint_id);

  handleAddEventBoardView({
    cardId,
    listId: destinationBoardListId,
    originalListId: cardListId,
    originalBoardId: boardId,
    destinationBoardId,
    newIndex: position,
    oldIndex: 0,
    storeGetters: store.getters,
    storeDispatch: store.dispatch,
  });

  store.dispatch('removeCardFromGroupByBoard', { boardId, card });
  store.dispatch('addCardToGroupByBoard', { boardId: destinationBoardId, card });

  return store
    .dispatch('updateCard', {
      cardId: card.id,
      card: {
        position,
        list_id: destinationBoardListId,
        board_id: destinationBoardId,
      },
      oldListId: cardListId,
    })
    .then(({ data }) => {
      const { card } = data;
      store.dispatch('addCardToCards', { card });
      if (card.sprint_id) {
        store.dispatch('localUpdateCardField', {
          cardId,
          fieldName: 'list_id',
          fieldValue: card.list_id,
        });
      }
      store.dispatch('getSprintsForProject', { projectId: card.project_id });
      const labels = store.getters.getIsCardDisplayed(card.id)
        ? []
        : [
            {
              text: translate('openCardInBoard'),
              type: constants.uiNotificationElements.button,
              callback: openCard,
              buttonStyle: 'important',
              params: store.getters.getCards[card.id],
            },
          ];
      if (showNotification) {
        store.dispatch('addUiNotification', {
          message: `${translate('moveCardIntoBoard')} ${destinationBoard.title}`,
          icon: 'info',
          labels,
          duration: 5000,
        });
      }
      return data;
    })
    .catch(() => {
      handleAddEventBoardView({
        cardId,
        listId: card.list_id,
        originalListId: destinationBoardListId,
        originalBoardId: destinationBoardId,
        destinationBoardId: boardId,
        newIndex: currentCardIndex,
        oldIndex: 0,
        storeGetters: store.getters,
        storeDispatch: store.dispatch,
      });
    });
};

export default dropCardIntoBoard;
